import ContentHeaderComponent from "../../layout/ContentHeaderComponent";

import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Upload,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import { Option } from "antd/es/mentions";

// Toast 에디터
import "@toast-ui/editor/dist/toastui-editor.css";
import "@toast-ui/editor/dist/i18n/ko-kr";
// Toast ColorSyntax 플러그인
import "tui-color-picker/dist/tui-color-picker.css";
import "@toast-ui/editor-plugin-color-syntax/dist/toastui-editor-plugin-color-syntax.css";
import fontSize from "tui-editor-plugin-font-size";

import "tui-editor-plugin-font-size/dist/tui-editor-plugin-font-size.css";
import moment from "moment";

import colorSyntax from "@toast-ui/editor-plugin-color-syntax";
import { Editor } from "@toast-ui/react-editor";

import nutrientsApi from "../../../apis/Nutrients.api";
import productApi from "../../../apis/Product.api";
import promotionApi from "../../../apis/Promotion.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import { plutusS3 } from "../../../utils/plutusS3";

const ContentCreateComponent = ({ match }) => {
  let history = useHistory();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));

  const [selectOptions, setSelectOptions] = useState({
    is_top: false,
  });
  const [content, setContent] = useState({
    is_exposure: true,
    is_best: false,
    top_banner: null,
    category: null,
    sub_category: null,
    seo_title: null,
    seo_author: "당신의 영양제",
    seo_description: null,
    seo_keywords: null,
    seo_image_alt: null,
  });
  const [contentImg, setContentImg] = useState(null);
  const [topBannerList, setTopBannerList] = useState([]);
  const [nutrientCategoryList, setNutrientCategoryList] = useState({
    vitamin: [],
    mineral: [],
    nutrition: [],
  });
  const [symptomList, setSymptomList] = useState([]);
  const [hashtags, setHashtags] = useState([
    {
      inputType: 0,
      inputValue: null,
    },
  ]);
  const [hashtagsCnt, setHashtagsCnt] = useState(0);
  // const [error, setError] = useState("");
  const editorRef = useRef(null);

  const exposureOptions = [
    { label: "노출", value: true },
    { label: "미노출", value: false },
  ];
  const bestOptions = [
    { label: "등록", value: true },
    { label: "해제", value: false },
  ];
  const bannerOptions = [
    { label: "1번", value: 1 },
    { label: "2번", value: 2 },
    { label: "3번", value: 3 },
    { label: "4번", value: 4 },
    { label: "5번", value: 5 },
  ];
  const categoryItemList = [
    { label: "비교하기", value: "compare" },
    { label: "영양 성분백과", value: "nutrition_encyclopedia" },
    { label: "대상별", value: "age" },
    { label: "증상별", value: "symptom" },
    { label: "트렌드", value: "trend" },
    { label: "선택기준", value: "selection" },
    { label: "브랜드", value: "brand" },
    { label: "기타", value: "etc" },
  ];
  const targetAgeItems = [
    { label: "0~2세", value: 0 },
    { label: "2~13세", value: 1 },
    { label: "0~13세", value: 2 },
    { label: "청소년", value: 3 },
    { label: "청소년부터 성인까지", value: 4 },
    { label: "성인", value: 5 },
    { label: "전 연령", value: 6 },
    // {label: "성인 여성", value: 7},
    // {label: "성인 남성", value: 8},
    { label: "50세 이상", value: 9 },
    // {label: "50세 이상 남성", value: 10},
    // {label: "50세 이상 여성", value: 11},
    { label: "임산부", value: 12 },
    { label: "기타", value: 99 },
  ];
  const inputOptions = [
    { label: "직접입력", value: 0 },
    { label: "영양성분", value: 1 },
    { label: "건강증상", value: 2 },
    { label: "연령", value: 3 },
  ];

  useEffect(() => {
    getTopBannserList();
    if (match.params.id) {
      readOneContent();
    } else {
      getNutrientSearchOption();
      getNutrientList();
      editorRef.current?.getInstance().setHTML("");
      setContent({
        is_exposure: true,
        is_best: false,
        top_banner: null,
        category: null,
        sub_category: null,
        seo_title: null,
        seo_author: "당신의 영양제",
        seo_description: null,
        seo_keywords: null,
        seo_image_alt: null,
      });
      setSelectOptions({ is_top: false });
      setHashtags([
        {
          inputType: 0,
          inputValue: null,
        },
      ]);
      setHashtagsCnt(0);
    }
  }, [match.params.id]);

  useEffect(() => {
    console.log("change content", content);
  }, [content]);

  useEffect(() => {
    console.log("change selectOptions", selectOptions);
  }, [selectOptions]);

  useEffect(() => {
    console.log("change hashtags", hashtags);
  }, [hashtags]);

  useEffect(() => {
    console.log("contentImg", contentImg);
  }, [contentImg]);

  const getNutrientSearchOption = async () => {
    setIsLoading(true);
    try {
      const res = await nutrientsApi.readNutrientSearchOption("");
      if (res.code === 200) {
        setSymptomList(res.result.nutrientEffectList);
        setIsLoading(false);
        return res.result.nutrientEffectList;
      } else {
        setIsLoading(false);
        throw `효능 정보를 가져오지 못했습니다. 다시 시도해주시길 바랍니다.`;
      }
    } catch (error) {
      setIsLoading(false);
      // setError(error);
      console.log("getNutrientSearchOption read error", error);
      alert(error);
    }
  };

  const getNutrientList = async () => {
    setIsLoading(true);
    try {
      const res = await productApi.readNutrientList();
      if (res.code === 200) {
        setNutrientCategoryList(res.result);
        setIsLoading(false);
        return res.result;
      } else {
        alert("영양소 정보를 가져오지 못했습니다. 다시 시도해주시길 바랍니다.");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      // setError(error);
      console.log("getNutrientList read error", error);
    }
  };

  const getTopBannserList = async () => {
    setIsLoading(true);
    try {
      const res = await promotionApi.readContentTopBanner();
      if (res.code === 200) {
        setTopBannerList(res.result);
      } else {
        alert("영양소 정보를 가져오지 못했습니다. 다시 시도해주시길 바랍니다.");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      // setError(error);
      console.log("getNutrientList read error", error);
    }
  };

  const readOneContent = async () => {
    setIsLoading(true);
    try {
      const res = await promotionApi.readContentById(match.params.id);
      if (res.code === 200) {
        console.log("readOneContent", res.result);
        const nutrientList = await getNutrientList();
        const nutrientEffectList = await getNutrientSearchOption();
        settingContent(res.result, nutrientEffectList, nutrientList);
      } else {
        alert(
          "수정할 콘텐츠 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.",
        );
        history.go(-1);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      // setError(error);
      console.log("readOneContent read error", error);
    }
  };

  const addImageBlobHook = async (blob, callback) => {
    // let fileType = blob.type.split("/")[1]
    let s3Path = `image/content/${moment(new Date()).format("YYMMDDHHmmss")}-${
      blob.name
    }`;
    let params = {
      Bucket: process.env.REACT_APP_S3_BUCKETNAME,
      Key: s3Path,
      Body: blob,
    };
    let res = await plutusS3.putObject(params).promise();

    if (res.success === true) {
      return callback(`${process.env.REACT_APP_S3_HOST}/${s3Path}`);
    } else {
      alert(
        "해당 파일을 업로드하는데 실패했습니다. 다시 시도해주시거나 관리자에게 문의해주시길 바랍니다.",
      );
    }
  };

  const saveContent = async () => {
    console.log("저장하기", editorRef.current?.getInstance());
    console.log("html", editorRef.current?.getInstance().getHTML());
    const validResult = validation();
    if (validResult) {
      setIsLoading(true);
      // setError(null);
      try {
        let res;
        const param = {
          ...content,
          content: editorRef.current?.getInstance().getHTML(),
          hashtag: hashtags
            .map((hashtag) => {
              if (hashtag.inputValue) {
                return hashtag.inputValue;
              }
            })
            .join(","),
          created_by: user.id,
          updated_by: user.id,
        };
        console.log("saveContent param", param);
        if (match.params.hasOwnProperty("id")) {
          res = await promotionApi.editContent(param);
        } else {
          res = await promotionApi.createContent(param);
        }
        if (res.code === 200) {
          console.log("콘텐츠 등록 성공", res.result);
          let mainImgResult;
          if (!contentImg.hasOwnProperty("mode")) {
            mainImgResult = await s3Upload(res.result.id);
          } else {
            console.log("메인 이미지 수정사항 없음");
            mainImgResult = true;
          }
          if (mainImgResult) {
            setIsLoading(false);
            alert(
              `해당 콘텐츠를 성공적으로 ${
                match.params.hasOwnProperty("id") ? "수정" : "등록"
              }했습니다.`,
            );
            // history.push(`/promotion/content/view`);
            history.push(`/content/view`);
          } else {
            throw `해당 콘텐츠의 썸네일을 서버에 저장하는 부분에서 오류가 발생했습니다.\n수정으로 다시 진행해주시거나 관리자에게 문의해주시길 바랍니다.`;
          }
        } else if (res.code === 999) {
          throw res.msg;
        } else {
          throw `해당 콘텐츠를 ${
            match.params.hasOwnProperty("id") ? "수정" : "등록"
          }하는 부분에서 오류가 발생했습니다.\n다시 시도해주시거나 관리자에게 문의해주시길 바랍니다.`;
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        // setError(error);
        console.log("saveContent save error", error);
        alert(error);
      }
    }
  };

  const s3Upload = async (contentId) => {
    // let fileType = file.type.split("/")[1]
    let s3Path = `image/contentMain/${contentId}.${content.mainImgType}`;
    let params = {
      Bucket: process.env.REACT_APP_S3_BUCKETNAME,
      Key: s3Path,
      Body: match.params.hasOwnProperty("id")
        ? contentImg.originFileObj
        : contentImg,
    };
    let res = await plutusS3.putObject(params).promise();

    return res.success === true;
  };

  const deleteContent = async () => {
    if (window.confirm("해당 게시물을 정말 삭제하시겠습니까?")) {
      setIsLoading(true);
      // setError(null);
      try {
        const deleteParam = {
          content_id: match.params.id,
          user_id: user.id,
        };
        const res = await promotionApi.deleteContent(deleteParam);
        if (res.code === 200) {
          setIsLoading(false);
          alert("해당 콘텐츠를 성공적으로 삭제했습니다.");
          // history.push(`/promotion/content/view`);
          history.push(`/content/view`);
        } else if (res.code === 406) {
          throw "해당 콘텐츠를 삭제하는데 실패하였습니다.\n다시 시도해주시거나 관리자에게 문의해주시길 바랍니다.";
        } else {
          throw res.msg;
        }
      } catch (error) {
        setIsLoading(false);
        // setError(error);
        console.log("deleteContent delete error", error);
        alert(error);
      }
    }
  };

  /**
   * 콘텐츠 기본 입력값 handler
   */
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "is_top") {
      if (!value) {
        setContent({ ...content, top_banner: null });
        setSelectOptions({ ...selectOptions, [name]: value });
      } else {
        if (!content.is_exposure) {
          alert("먼저 해당 콘텐츠를 노출로 설정해주세요.");
        } else {
          setSelectOptions({ ...selectOptions, [name]: value });
        }
      }
    } else if (name === "is_exposure") {
      if (!value) {
        setContent({ ...content, [name]: value, top_banner: null });
        setSelectOptions({ ...selectOptions, is_top: value });
      } else {
        setContent({ ...content, [name]: value });
      }
    } else {
      setContent({ ...content, [name]: value });
    }
  };

  /**
   * categoru 선택 함수
   */
  const handleCategorySelect = (level, categoryValue) => {
    if (level === 1) {
      setContent({ ...content, category: categoryValue, sub_category: null });
    } else if (level === 2) {
      setContent({ ...content, sub_category: categoryValue });
    }
  };

  /**
   * Image 업로드
   */
  const handleImageChange = ({ file, fileList, event }) => {
    console.log("handleImageChange", file);
    if (match.params.hasOwnProperty("id")) {
      if (file.status === "removed") {
        setContentImg(null);
        setContent({ ...content, mainImgType: null });
      } else {
        const editFile = {
          uid: file.uid,
          name: file.name,
          status: "done",
          url: URL.createObjectURL(file),
          originFileObj: file,
        };
        setContentImg(editFile);
        setContent({ ...content, mainImgType: file.type.split("/")[1] });
      }
    } else {
      setContentImg(file);
      setContent({ ...content, mainImgType: file.type.split("/")[1] });
    }
  };

  const handlePreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  /**
   * 옵션 추가
   */
  const addOption = () => {
    setHashtags([...hashtags, { inputType: 0, inputValue: null }]);
  };

  /**
   * 옵션 삭제
   */
  const deleteOptions = (index) => {
    let currList = Array.from(hashtags);
    let currCnt = hashtagsCnt;
    if (currList[index].inputValue) {
      if (currList[index].inputType === 0) {
        currCnt -= 1;
      } else {
        currCnt -= currList[index].inputValue.split(",")?.length;
      }
    }
    currList.splice(index, 1);
    setHashtags(currList);
    setHashtagsCnt(currCnt);
  };

  /**
   * 옵션 handleChange
   */
  const handleOptionChange = (e, index) => {
    let count = 0;
    const { name, value } = e.target;
    let currHashtags = Array.from(hashtags);
    // 현재 해시태그 갯수가 5개인 상태
    if (hashtagsCnt >= 5) {
      if (e.target.hasOwnProperty("checked")) {
        const checked = e.target.checked;
        // 현재 해시태그 갯수가 5개인 상태 + 해시태그를 추가하려는 상태 => 현재 선택한 값 빼주기
        let splitted = currHashtags[index][name].split(",");
        const deleteIdx = splitted.findIndex(
          (currValue) => currValue === value,
        );
        if (deleteIdx !== -1) {
          splitted.splice(deleteIdx, 1);
        }
        if (splitted?.length === 0) {
          currHashtags[index][name] = null;
        } else {
          currHashtags[index][name] = splitted.join(",");
        }

        if (checked) {
          alert(
            "해시태그는 최대 5개까지 입력할 수 있습니다. 선택한 해시태그를 선택 해제해 주시거나 항목을 삭제한 후 등록해주세요!",
          );
        }
      } else {
        // 현재 해시태그 갯수가 5개인 상태 + 기존 해시태그의 값을 수정하려는 상황
        if (currHashtags[index][name]) {
          currHashtags[index][name] = value;
        } else {
          // 현재 해시태그 갯수가 5개인 상태 + 해시태그를 추가하려는 상태
          currHashtags[index][name] = null;
          alert(
            "해시태그는 최대 5개까지 입력할 수 있습니다. 선택한 해시태그를 선택 해제해 주시거나 항목을 삭제한 후 등록해주세요!",
          );
        }
      }
    } else {
      if (e.target.hasOwnProperty("checked")) {
        const checked = e.target.checked;
        if (checked) {
          if (currHashtags[index][name]) {
            currHashtags[index][name] += "," + value;
          } else {
            currHashtags[index][name] = value;
          }
        } else {
          let splitted = currHashtags[index][name].split(",");
          const deleteIdx = splitted.findIndex(
            (currValue) => currValue === value,
          );
          if (deleteIdx !== -1) {
            splitted.splice(deleteIdx, 1);
          }
          if (splitted?.length === 0) {
            currHashtags[index][name] = null;
          } else {
            currHashtags[index][name] = splitted.join(",");
          }
        }
      } else {
        currHashtags[index][name] = value;
      }
    }
    for (const hashtag of currHashtags) {
      if (hashtag.inputType === 0) {
        if (hashtag.inputValue) {
          count += 1;
        }
      } else {
        if (hashtag.inputValue) {
          count += hashtag.inputValue.split(",")?.length;
        }
      }
    }
    setHashtags(currHashtags);
    setHashtagsCnt(count);
  };

  /**
   * 옵션 Select input handler
   */
  const handleSelectChange = (value, e) => {
    let currHashtags = Array.from(hashtags);
    if (e.id === "inputType") {
      currHashtags[parseInt(e.key.split("-")[0])][e.id] = value;
    } else {
      currHashtags[parseInt(e.key)][e.id] = value;
    }
    setHashtags(currHashtags);
  };

  /**
   * 취소 버튼
   */
  const cancelBtnClick = () => {
    if (
      window.confirm(
        "해당 페이지에서 나가면 지금까지 작성했던 기록들이 전부 사라집니다.\n그래도 나가시겠습니까?",
      )
    ) {
      history.go(-1);
    }
  };

  const validation = () => {
    if (selectOptions.is_top && !content.top_banner) {
      alert("상단 배너를 몇번째에 노출시킬지를 선택해주시길 바랍니다.");
      return false;
    } else if (!content.category) {
      alert("카테고리를 선택해주시길 바랍니다.");
      return false;
    } else if (
      (content.category === "age" || content.category === "symptom") &&
      !content.sub_category
    ) {
      alert("서브 카테고리를 선택해주시길 바랍니다.");
      return false;
    } else if (!content.hasOwnProperty("mainImgType") || !content.mainImgType) {
      alert("대표이미지를 선택해주시길 바랍니다.");
      return false;
    } else if (!content.hasOwnProperty("head_copy") || !content.head_copy) {
      alert("헤드 카피를 입력해주시길 바랍니다.");
      return false;
    } else {
      return true;
    }
  };

  /**
   * 콘텐츠 수정값 setting
   */
  const settingContent = (contentInfo, nutrientEffectList, nutrientList) => {
    let editContentInfo = {};
    let editSelectOptions = {};
    let editHashTags = [];
    let editHashTagsCnt = 0;
    let editMainImg = {};
    for (const key in contentInfo) {
      if (key === "top_banner") {
        if (contentInfo[key]) {
          editSelectOptions["is_top"] = true;
        } else {
          editSelectOptions["is_top"] = false;
        }
        editContentInfo[key] = contentInfo[key];
      } else if (key === "content") {
        editorRef.current?.getInstance().setHTML(contentInfo[key]);
      } else if (key === "mainImgType") {
        const thumbnail = {
          uid: contentInfo["id"],
          name: `${contentInfo["id"]}.${contentInfo[key]}`,
          status: "done",
          mode: "s3",
          url: `${process.env.REACT_APP_S3_HOST}/image/contentMain/${contentInfo["id"]}.${contentInfo[key]}`,
        };
        editMainImg = thumbnail;
        editContentInfo[key] = contentInfo[key];
      } else if (key === "hashtag") {
        if (contentInfo[key]) {
          let effectHashtagList = [];
          let nutrientHashtagList = [];
          let ageHashtagList = [];
          const splitted = contentInfo[key].split(",");
          for (const hashtag of splitted) {
            editHashTagsCnt += 1;
            const findAge = targetAgeItems.findIndex(
              (age) => age.label === hashtag,
            );
            if (findAge !== -1) {
              ageHashtagList.push(hashtag);
            } else {
              const findEffect = nutrientEffectList.findIndex(
                (effect) => effect.effect_name === hashtag,
              );
              if (findEffect !== -1) {
                effectHashtagList.push(hashtag);
              } else {
                const findVitamin = nutrientList.vitamin.findIndex(
                  (vitamin) => vitamin.nutrient_name === hashtag,
                );
                if (findVitamin !== -1) {
                  nutrientHashtagList.push(hashtag);
                } else {
                  const findMineral = nutrientList.mineral.findIndex(
                    (mineral) => mineral.nutrient_name === hashtag,
                  );
                  if (findMineral !== -1) {
                    nutrientHashtagList.push(hashtag);
                  } else {
                    const findNutrition = nutrientList.nutrition.findIndex(
                      (nutrition) => nutrition.nutrient_name === hashtag,
                    );
                    if (findNutrition !== -1) {
                      nutrientHashtagList.push(hashtag);
                    } else {
                      editHashTags.push({ inputType: 0, inputValue: hashtag });
                    }
                  }
                }
              }
            }
          }
          if (nutrientHashtagList?.length !== 0) {
            editHashTags.push({
              inputType: 1,
              inputValue: nutrientHashtagList.join(","),
            });
          }
          if (effectHashtagList?.length !== 0) {
            editHashTags.push({
              inputType: 2,
              inputValue: effectHashtagList.join(","),
            });
          }
          if (ageHashtagList?.length !== 0) {
            editHashTags.push({
              inputType: 3,
              inputValue: ageHashtagList.join(","),
            });
          }
          // 해씨태그가 없어서 초기값 추가
          if (editHashTags?.length === 0) {
            editHashTags.push({ inputType: 0, inputValue: null });
          }
        } else {
          // 해씨태그가 없어서 초기값 추가
          editHashTags.push({ inputType: 0, inputValue: null });
        }
      } else if (
        key === "created_by_name" ||
        key === "updated_at" ||
        key === "updated_by" ||
        key === "updated_by_name"
      ) {
        /* empty */
      } else {
        editContentInfo[key] = contentInfo[key];
      }
    }
    setContent(editContentInfo);
    setSelectOptions(editSelectOptions);
    setHashtags(editHashTags);
    setHashtagsCnt(editHashTagsCnt);
    setContentImg(editMainImg);
  };

  return (
    <>
      <ContentHeaderComponent title="콘텐츠 발행" />
      <div className="product-register-wrap">
        {/*전시상태*/}
        <Row
          className="product-register-border-box"
          style={{ marginTop: 20, marginBottom: 18 }}
        >
          <span className="product-register-box-title">전시 상태</span>
          <span className="product-register-box-sign">*</span>
          <Radio.Group
            name="is_exposure"
            options={exposureOptions}
            onChange={handleChange}
            value={content.is_exposure}
            className="product-register-purchase-status-wrap"
            optionType="button"
            buttonStyle="solid"
          />
        </Row>

        {/*베스트*/}
        <Row
          className="product-register-border-box"
          style={{ marginTop: 20, marginBottom: 18 }}
        >
          <span className="product-register-box-title">베스트</span>
          <span className="product-register-box-sign">*</span>
          <Radio.Group
            name="is_best"
            options={bestOptions}
            onChange={handleChange}
            value={content.is_best}
            className="product-register-purchase-status-wrap"
            optionType="button"
            buttonStyle="solid"
          />
        </Row>

        {/*상단 배너*/}
        <Row
          className="product-register-border-box"
          style={{ marginTop: 20, marginBottom: 18 }}
        >
          <span className="product-register-box-title">상단 배너</span>
          <span className="product-register-box-sign">*</span>
          <Radio.Group
            name="is_top"
            options={exposureOptions}
            onChange={handleChange}
            value={selectOptions.is_top}
            className="product-register-purchase-status-wrap"
            optionType="button"
            buttonStyle="solid"
          />
          {selectOptions.is_top && (
            <Radio.Group
              name="top_banner"
              onChange={handleChange}
              value={content.top_banner}
              className="content-register-top-banner-wrap"
            >
              {bannerOptions.map((option, idx) => {
                const findIdx = topBannerList.findIndex((topBanner) => {
                  if (content.hasOwnProperty("id")) {
                    return (
                      topBanner.id !== content.id &&
                      topBanner.top_banner === option.value
                    );
                  } else {
                    return topBanner.top_banner === option.value;
                  }
                });
                return (
                  <Radio
                    key={`is_banner_option_${idx}`}
                    value={option.value}
                    disabled={findIdx !== -1}
                  >
                    {option.label}
                  </Radio>
                );
              })}
            </Radio.Group>
          )}
        </Row>

        {/*카테고리*/}
        <Row
          className="product-register-border-box"
          wrap={false}
          style={{ marginTop: 18 }}
        >
          <span className="product-register-box-title">카테고리</span>
          <span className="product-register-box-sign">*</span>
        </Row>
        <Row
          className="product-register-border-box"
          wrap={false}
          style={{ borderTop: 0, padding: "30px 33px", height: 300 }}
        >
          <Col className="product-register-category-wrap" span={12}>
            {categoryItemList.map((category, idx) => (
              <Row
                key={`content_category_${idx}`}
                className={
                  "product-register-category-item-wrap" +
                  (content.category === category.value ? " selected" : "")
                }
                wrap={false}
                onClick={() => handleCategorySelect(1, category.value)}
              >
                <Col className="product-register-category-name" flex="auto">
                  {category.label}
                </Col>
                {category.value === "age" || category.value === "symptom" ? (
                  <img
                    className="product-register-category-icon"
                    src={`${process.env.REACT_APP_HOST}/assets/images/product/Icon-2.png`}
                  />
                ) : null}
              </Row>
            ))}
          </Col>
          <Col className="product-register-category-wrap" span={12}>
            {content.category === "age" || content.category === "symptom" ? (
              content.category === "age" && targetAgeItems?.length !== 0 ? (
                <>
                  {targetAgeItems.map((age, idx) => (
                    <Row
                      key={`content_category_age_${idx}`}
                      className={
                        "product-register-category-item-wrap" +
                        (content.sub_category !== null &&
                        parseInt(content.sub_category) === age.value
                          ? " selected"
                          : "")
                      }
                      wrap={false}
                      onClick={() => handleCategorySelect(2, age.value)}
                    >
                      <Col
                        className="product-register-category-name"
                        flex="auto"
                      >
                        {age.label}
                      </Col>
                    </Row>
                  ))}
                </>
              ) : content.category === "symptom" &&
                symptomList?.length !== 0 ? (
                <>
                  {symptomList.map((symptom, idx) => (
                    <Row
                      key={`content_category_symptom_${idx}`}
                      className={
                        "product-register-category-item-wrap" +
                        (content.sub_category !== null &&
                        content.sub_category === symptom.effect_id
                          ? " selected"
                          : "")
                      }
                      wrap={false}
                      onClick={() => handleCategorySelect(2, symptom.effect_id)}
                    >
                      <Col
                        className="product-register-category-name"
                        flex="auto"
                      >
                        {symptom.effect_name}
                      </Col>
                    </Row>
                  ))}
                </>
              ) : null
            ) : null}
          </Col>
        </Row>

        {/*에디터*/}
        <Row
          className="product-register-border-box"
          wrap={false}
          style={{ marginTop: 35, borderBottom: 0 }}
        >
          <span className="product-register-box-title">에디터</span>
        </Row>
        <div className="content-register-editor-wrap">
          <Editor
            placeholder="내용을 입력해주세요."
            height="1500px" // 에디터 창 높이
            // previewStyle="vertical" // 미리보기 스타일 지정
            hideModeSwitch={true}
            language="ko-KR"
            initialEditType="wysiwyg" // 초기 입력모드 설정(디폴트 markdown)
            // toolbarItems={[
            //     // 툴바 옵션 설정
            //     ['heading', 'bold', 'italic', 'strike'],
            //     ['hr', 'quote'],
            //     ['ul', 'ol', 'task', 'indent', 'outdent'],
            //     ['table', 'image', 'link'],
            //     ['code', 'codeblock']
            // ]}
            plugins={[colorSyntax, fontSize]}
            hooks={{
              addImageBlobHook: addImageBlobHook,
            }}
            ref={editorRef}
          ></Editor>
        </div>

        {/*썸네일/배너*/}
        <Row
          className="product-register-border-box"
          wrap={false}
          style={{ marginTop: 23 }}
        >
          <span className="product-register-box-title">썸네일/배너</span>
          <span className="product-register-box-sign">*</span>
        </Row>
        <div
          className="product-register-border-box"
          wrap={false}
          style={{
            borderTop: 0,
            padding: "20px 25px 0",
            height: "fit-content",
          }}
        >
          <Form.Item
            label="대표이미지"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 2 }}
            wrapperCol={{ span: 22 }}
          >
            {match.params.hasOwnProperty("id") ? (
              <Upload
                className="product-register-upload-img-wrap"
                // action="/upload.do"
                listType="picture-card"
                maxCount={1}
                fileList={contentImg ? [contentImg] : null}
                onChange={handleImageChange}
                onPreview={handlePreview}
                beforeUpload={() => false}
              >
                {contentImg ? null : (
                  <div className="product-register-upload-img-icon-wrap">
                    <img
                      className="product-register-upload-img-icon"
                      src={`${process.env.REACT_APP_HOST}/assets/images/product/Icon-1.png`}
                    />
                  </div>
                )}
              </Upload>
            ) : (
              <Upload
                className="product-register-upload-img-wrap"
                // action="/upload.do"
                listType="picture-card"
                maxCount={1}
                // fileList={contentImg ? [contentImg] : []}
                onChange={handleImageChange}
                onPreview={handlePreview}
                beforeUpload={(file) => false}
              >
                <div className="product-register-upload-img-icon-wrap">
                  <img
                    className="product-register-upload-img-icon"
                    src={`${process.env.REACT_APP_HOST}/assets/images/product/Icon-1.png`}
                  />
                </div>
              </Upload>
            )}
            {/*<span className="product-register-upload-img-help">권장크기 : 1000 x 1000px</span>*/}
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="center-label"
            label="헤드 카피"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 2 }}
            wrapperCol={{ span: 22 }}
          >
            <Input
              name="head_copy"
              value={content.head_copy}
              onChange={handleChange}
            />
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="product-register-form-input-wrap"
            label="서브 카피"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 2 }}
            wrapperCol={{ span: 22 }}
          >
            <TextArea
              name="sub_copy"
              value={content.sub_copy}
              onChange={handleChange}
            />
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="product-option-wrap content-register-hashtag-label pre-line"
            label={
              <>
                {"해시태그\n"}
                <div className="hashtag-label-highlight">{hashtagsCnt}/5</div>
              </>
            }
            labelAlign="left"
            colon={false}
            labelCol={{ span: 2 }}
            wrapperCol={{ span: 22 }}
          >
            <div
              className="product-option-list-wrap"
              style={{ overflowX: "visible" }}
            >
              {hashtags.map((hashtag, index) => (
                <Row
                  wrap={false}
                  gutter={8}
                  className="product-option-row-wrap"
                >
                  <Col flex="none" style={{ textAlign: "end" }}>
                    <div className="product-option-button-wrap">
                      {hashtags?.length - 1 === index && index !== 4 ? (
                        <Button
                          className="product-option-button"
                          icon={
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={`${process.env.REACT_APP_HOST}/assets/images/product/product-option-add.png`}
                            />
                          }
                          onClick={addOption}
                        ></Button>
                      ) : null}
                      {hashtags?.length !== 1 ? (
                        <Button
                          className="product-option-button"
                          icon={
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={`${process.env.REACT_APP_HOST}/assets/images/product/product-option-delete.png`}
                            />
                          }
                          onClick={() => deleteOptions(index)}
                          style={{ marginLeft: 10 }}
                        ></Button>
                      ) : null}
                    </div>
                  </Col>
                  <Col span={4}>
                    <Select
                      value={hashtag.inputType}
                      onChange={handleSelectChange}
                    >
                      {inputOptions.map((inputOption, idx) => (
                        <Option
                          key={`${index}-${idx}`}
                          id="inputType"
                          value={inputOption.value}
                        >
                          {inputOption.label}
                        </Option>
                      ))}
                    </Select>
                  </Col>
                  <Col flex="auto">
                    {hashtag.inputType === 0 ? (
                      <Input
                        name="inputValue"
                        value={hashtag.inputValue}
                        onChange={(e) => handleOptionChange(e, index)}
                      />
                    ) : hashtag.inputType === 1 ? (
                      <div className="content-register-hashtag-wrap">
                        <p className="product-register-nutrients-subtitle">
                          비타민
                        </p>
                        <Row style={{ rowGap: 8, marginBottom: 20 }}>
                          {nutrientCategoryList.vitamin?.length !== 0 &&
                            nutrientCategoryList.vitamin.map((vitamin) => (
                              <Col span={6}>
                                <Checkbox
                                  key={vitamin.id}
                                  id={vitamin.nutrient_id}
                                  name="inputValue"
                                  value={vitamin.nutrient_name}
                                  onChange={(e) => handleOptionChange(e, index)}
                                  checked={
                                    hashtag.inputValue &&
                                    hashtag.inputValue.includes(
                                      vitamin.nutrient_name,
                                    )
                                  }
                                >
                                  {vitamin.nutrient_name}
                                </Checkbox>
                              </Col>
                            ))}
                        </Row>
                        <p className="product-register-nutrients-subtitle">
                          미네랄
                        </p>
                        <Row style={{ rowGap: 8, marginBottom: 20 }}>
                          {nutrientCategoryList.mineral?.length !== 0 &&
                            nutrientCategoryList.mineral.map((mineral) => (
                              <Col span={6}>
                                <Checkbox
                                  key={mineral.id}
                                  id={mineral.nutrient_id}
                                  name="inputValue"
                                  value={mineral.nutrient_name}
                                  onChange={(e) => handleOptionChange(e, index)}
                                  checked={
                                    hashtag.inputValue &&
                                    hashtag.inputValue.includes(
                                      mineral.nutrient_name,
                                    )
                                  }
                                >
                                  {mineral.nutrient_name}
                                </Checkbox>
                              </Col>
                            ))}
                        </Row>
                        <p className="product-register-nutrients-subtitle">
                          뉴트리션
                        </p>
                        <Row style={{ rowGap: 8, marginBottom: 20 }}>
                          {nutrientCategoryList.nutrition?.length !== 0 &&
                            nutrientCategoryList.nutrition.map((nutrition) => (
                              <Col span={6}>
                                <Checkbox
                                  key={nutrition.id}
                                  id={nutrition.nutrient_id}
                                  name="inputValue"
                                  value={nutrition.nutrient_name}
                                  onChange={(e) => handleOptionChange(e, index)}
                                  checked={
                                    hashtag.inputValue &&
                                    hashtag.inputValue.includes(
                                      nutrition.nutrient_name,
                                    )
                                  }
                                >
                                  {nutrition.nutrient_name}
                                </Checkbox>
                              </Col>
                            ))}
                        </Row>
                      </div>
                    ) : hashtag.inputType === 2 ? (
                      <div className="content-register-hashtag-wrap">
                        <Row style={{ rowGap: 8 }}>
                          {symptomList.map((effect, idx) => (
                            <Col span={6}>
                              <Checkbox
                                key={`effect_${idx}`}
                                id={effect.effect_id}
                                name="inputValue"
                                value={effect.effect_name}
                                onChange={(e) => handleOptionChange(e, index)}
                                checked={
                                  hashtag.inputValue &&
                                  hashtag.inputValue.includes(
                                    effect.effect_name,
                                  )
                                }
                              >
                                {effect.effect_name}
                              </Checkbox>
                            </Col>
                          ))}
                        </Row>
                      </div>
                    ) : hashtag.inputType === 3 ? (
                      <div className="content-register-hashtag-wrap">
                        <Row style={{ rowGap: 8 }}>
                          {targetAgeItems.map((targetAge, idx) => (
                            <Col span={6}>
                              <Checkbox
                                key={`targetAge_${idx}`}
                                name="inputValue"
                                value={targetAge.label}
                                onChange={(e) => handleOptionChange(e, index)}
                                checked={
                                  hashtag.inputValue &&
                                  hashtag.inputValue.includes(targetAge.label)
                                }
                              >
                                {targetAge.label}
                              </Checkbox>
                            </Col>
                          ))}
                        </Row>
                      </div>
                    ) : null}
                  </Col>
                </Row>
              ))}
            </div>
          </Form.Item>
        </div>

        {/*SEO*/}
        <Row
          className="product-register-border-box"
          wrap={false}
          style={{ marginTop: 27 }}
        >
          <span className="product-register-box-title">SEO</span>
        </Row>
        <div
          className="product-register-border-box"
          wrap={false}
          style={{
            borderTop: 0,
            padding: "20px 25px 0",
            height: "fit-content",
          }}
        >
          <Form.Item
            className="center-label pre-line"
            label={"브라우저 타이틀\n:Title"}
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Input
              name="seo_title"
              value={content.seo_title}
              onChange={handleChange}
            />
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="center-label pre-line"
            label={"메타태그1\n:Author"}
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Input
              name="seo_author"
              value={content.seo_author}
              onChange={handleChange}
            />
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="product-register-form-input-wrap pre-line"
            label={"메타태그2\n:Description"}
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Input.TextArea
              name="seo_description"
              value={content.seo_description}
              onChange={handleChange}
            />
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="pre-line"
            label={"메타태그3\n:Keywords"}
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Input.TextArea
              name="seo_keywords"
              value={content.seo_keywords}
              onChange={handleChange}
              style={{ resize: "none", minHeight: 110 }}
            />
            <div className="product-register-search-tag-help">
              - 키워드는 콤마(,)로 구분하여 입력합니다.
            </div>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            label="상품 이미지 Alt 텍스트"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Input
              name="seo_image_alt"
              value={content.seo_image_alt}
              onChange={handleChange}
            />
            <div className="product-register-search-tag-help">
              - Alt 텍스트는 해당 상품을 표현할 수 있는 1개 ~ 2개 정도의 단어로
              입력하세요.
            </div>
          </Form.Item>
        </div>
      </div>
      <div className="product-register-fixed-footer" tabIndex={0}>
        {/*<Button className="product-register-button temporary">임시저장</Button>*/}
        <Button
          className="product-register-button save"
          onClick={saveContent}
          loading={isLoading}
        >
          {isLoading
            ? null
            : match.params.hasOwnProperty("id")
            ? "수정"
            : "저장"}
        </Button>
        <Button
          className="product-register-button cancel"
          onClick={cancelBtnClick}
        >
          취소
        </Button>
        {match.params.hasOwnProperty("id") && (
          <Button
            className="product-register-button delete"
            onClick={deleteContent}
          >
            삭제
          </Button>
        )}
      </div>
    </>
  );
};

export default ContentCreateComponent;
